import { useState, useEffect, useCallback, useRef } from "react";
import tw from "tailwind-styled-components";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
    BoxTitle,
    BoxContainer,
    BoxHead,
    Underline,
    FilterTableWrapper,
    FilterWrapperWithSearch,
    FilterWrapper,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import NotFoundModel from "../../Components/NotFoundModel";
import SideModal from "../../Components/SideModal";
import { toast } from "react-toastify";
import { Form, Formik } from "formik";
import CreateStaffWallet from "../../Components/Payout/StaffWallet/CreateStaffWallet";
import Table from "../../Components/Payout/StaffWallet/StaffWalletTable";
import ViewBeneficiaryDetails from "../../Components/Payout/ViewBeneficiaryDetails";
import moment from "moment";
import SearchFilterBox from "../../Components/SearchFilterBox";
import DateRange from "../../Components/DateRange";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import SummaryCards from "../../Components/Payout/StaffWallet/Summary";
import useDeleteMutation from "../../utilities/useDeleteMutation";
import DeleteModal from "../../Components/Common/DeleteModal";
import ConfirmModal from "../../Components/Common/ConfirmModal";
import useVerifyBankAccount from "../../utilities/useVerifyBankAccount";
import TransferFundToWallet from "../../Components/Payout/StaffWallet/TransferFundToWallet";
import WithdrawFundFromWallet from "../../Components/Payout/StaffWallet/WithdrawFundFromWallet";
import ViewStaffWalletTransfers from "../../Components/Payout/StaffWallet/ViewStaffWalletTransfers";
import EditStaffWallet from "../../Components/Payout/StaffWallet/Edit";

const StaffWallet = () => {
    const searchOptions = [
        { label: "Mobile", value: 1 },
        { label: "Name", value: 2 },
        // { label: "UTR", value: 3 },
        // { label: "Account", value: 3 },
    ];
    const initialLoadRef = useRef(false);

    // const staffList = useSelector((state) => state.StaffListReducer.staffList);
    // const staffListOptions = staffList
    //     ?.filter(type => type?.name && type?.id)
    //     .map(type => ({
    //         label: type.name,
    //         value: type.id,
    //     }));
    const [summaryData, setSummaryData] = useState();
    const [staffListing, setStaffListing] = useState();
    const [selectedId, setSelectedId] = useState(null);
    const user = useSelector((state) => state.UserReducer.user);
    const [selectedData, setSelectedData] = useState("");
    const [apiData, setApiData] = useState([]);
    const [apiStaffTransferData, setStaffTransferApiData] = useState([]);
    const [showCreateWalletModal, setShowCreateWalletModal] = useState(false);
    const [viewDetails, setViewDetails] = useState(false);
    const [isDeleteEntity, setIsDeleteEntity] = useState(false);
    const [showActivateModal, setShowActivateModal] = useState(false);
    const [showDeactivateModal, setShowDeactivateModal] = useState(false);
    const [showTransferFundModal, setShowTransferFundModal] = useState(false);
    const [showWithdrawFundModal, setShowWithdrawFundModal] = useState(false);
    const [showStaffWalletFundTransfersModal, setShowStaffWalletFundTransfersModal] = useState(false);
    const [isEditStaff, setIsEditStaffWallet] = useState(false);

    const [searchQuery, setSearchQuery] = useState("");
    const [startDate, setStartDate] = useState(
        sessionStorage.getItem("beneficiary_startDate") ||
        moment().startOf("month").format("YYYY-MM-DD")
    );
    const [endDate, setEndDate] = useState(
        sessionStorage.getItem("beneficiary_endDate") ||
        moment(new Date()).format("YYYY-MM-DD")
    );
    const [filterType, setFilterType] = useState("");

    const buildQueryParams = useCallback(() => {
        const params = new URLSearchParams();
        params.append('startDate', startDate);
        params.append('endDate', endDate);
        if (searchQuery) {
            params.append('s', searchQuery);
        }
        if (filterType) params.append('t', filterType);
        return params.toString();
    }, [startDate, endDate, searchQuery, filterType]);

    const fetchFunction = async () => {
        const query = buildQueryParams();
        const response = await axios.get(
            `${Config.apiUrl}/wallet/list?${query}`,
            {
                headers: {
                    authorization: `Bearer ${user.token}`,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );
        return response.data;
    };

    const getSuccess = (res) => {
        if (res.data === false) {
            setApiData([]);

        } else {
            const data = res?.data || [];
            setApiData(data);
            setSummaryData(res?.summary);
            const staffLists = res?.staffWithoutWallet
                ?.filter(type => type?.name && type?.id)
                .map(type => ({
                    label: type.name,
                    value: type.id,
                }));
            setStaffListing(staffLists);
        }
    };

    const getError = () => {
        setApiData([]);
    };

    const {
        isLoading,
        mutate: getListMutate,
        error,
        data,
        isRefetching,
    } = useMutation(fetchFunction, {
        onSuccess: getSuccess,
        onError: getError,
    });

    useEffect(() => {
        if (initialLoadRef.current) {
            return;
        }

        initialLoadRef.current = true;

        getListMutate();
    }, []);


    //------- Add Beneficiary Account -------
    const createWalletFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/wallet/add`, values, {
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${user.token}`,
            },
        });
    };

    const createWalletSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg);
            setShowCreateWalletModal(false);
            getListMutate();
        } else {
            toast.error(data?.data?.msg);
        }
    };

    const createWalletError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: createWalletLoading, mutate: createWalletMutate } =
        useMutation(createWalletFunction, {
            onSuccess: createWalletSuccess,
            onError: createWalletError,
        });

    const handleClose = () => {
        setShowCreateWalletModal(false);
    };

    const submitHandler = (values) => {
        const newValues = {
            startDate: moment(values.startDate).format("YYYY-MM-DD"),
            endDate: moment(values.endDate).format("YYYY-MM-DD"),
        };
        setFilterType("");
        setSearchQuery("");
        setStartDate(newValues.startDate);
        setEndDate(newValues.endDate);
        const handler = setTimeout(() => {
            getListMutate();
        }, 100);
        return () => {
            clearTimeout(handler);
        };
    };

    const handleFilterChange = (values) => {
        setFilterType(values.filterType);
        setSearchQuery(values.searchQuery);
        const handler = setTimeout(() => {
            getListMutate();
        }, 100);
        return () => {
            clearTimeout(handler);
        };
    };

    const handleClearFilters = () => {
        setFilterType("");
        setSearchQuery("");
        const handler = setTimeout(() => {
            getListMutate();
        }, 100);
        return () => {
            clearTimeout(handler);
        };
    };

    const onSummaryBoxClick = (data) => {
        // sessionStorage.removeItem("properties_page_index");
        // setActiveFilter({ value: "", label: "", title: "" });
        // setIsFilterOpen(false);
        // setFilter(data);
        // const handler = setTimeout(() => {
        //     getListMutate();
        // }, 100);

        // return () => {
        //     clearTimeout(handler);
        // };
    };

    const {
        isLoading: deleteEntityLoading,
        mutate: deleteEntityMutate,
    } = useDeleteMutation({
        endpoint: "/cashfree/payout/delete/beneficiary",
        token: user.token,
        closeModal: () => setIsDeleteEntity(false),
        refetch: () =>
            getListMutate()
    });

    const {
        isLoading: deactivateWalletLoading,
        mutate: deactivateWalletMutate,
    } = useDeleteMutation({
        endpoint: "/cashfree/payout/deactivate/beneficiary",
        token: user.token,
        closeModal: () => setShowDeactivateModal(false),
        refetch: () => getListMutate(),
    });

    const {
        isLoading: activateWalletLoading,
        mutate: activateWalletMutate,
    } = useDeleteMutation({
        endpoint: "/cashfree/payout/activate/beneficiary",
        token: user.token,
        closeModal: () => setShowActivateModal(false),
        refetch: () => getListMutate(),
    });

    const TransferFundFunction = async (values) => {
        return await axios.post(
            `${Config.apiUrl}/wallet/fund/add`,
            values,
            {
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${user.token}`,
                },
            }
        );
    };

    const transferFundSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(
                data?.data?.msg || "Funds transferred to staff wallet successfully"
            );

            setShowTransferFundModal(false);
            setSelectedData(null);

            // Refresh wallet list/balance
            getListMutate();
        } else {
            toast.error(
                data?.data?.msg || "Unable to transfer funds"
            );
        }
    };

    const transferFundError = (error) => {
        toast.error(
            error?.response?.data?.msg ||
            "An error occurred while transferring funds"
        );
    };

    const {
        isLoading: transferFundLoading,
        mutate: transferFundMutate,
    } = useMutation(TransferFundFunction, {
        onSuccess: transferFundSuccess,
        onError: transferFundError,
    });

    // Withdraw fund API
    const WithdrawFundFunction = async (values) => {
        return await axios.post(
            `${Config.apiUrl}/wallet/fund/withdraw`,
            values,
            {
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${user.token}`,
                },
            }
        );
    };

    const withdrawFundSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(
                data?.data?.msg || "Funds withdraw from staff wallet successfully"
            );

            setShowWithdrawFundModal(false);
            setSelectedData(null);

            // Refresh wallet list/balance
            getListMutate();
        } else {
            toast.error(
                data?.data?.msg || "Unable to transfer funds"
            );
        }
    };

    const withdrawFundError = (error) => {
        toast.error(
            error?.response?.data?.msg ||
            "An error occurred while transferring funds"
        );
    };

    const {
        isLoading: withdrawFundLoading,
        mutate: withdrawFundMutate,
    } = useMutation(WithdrawFundFunction, {
        onSuccess: withdrawFundSuccess,
        onError: withdrawFundError,
    });

    // Staff Wallet Transfer API
    const fetchStaffWalletTransfers = async (staffId) => {
        const params = new URLSearchParams();
        // params.append("startDate", startDate);
        // params.append("endDate", endDate);
        params.append("staffId", staffId);
        const query = params.toString();

        const response = await axios.get(
            `${Config.apiUrl}/wallet/list/transfers/staff?${query}`,
            {
                headers: {
                    authorization: `Bearer ${user.token}`,
                    "Content-Type":
                        "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );

        return response.data;
    };

    const getTransferListSuccess = (res) => {
        if (res?.data === false) {
            setStaffTransferApiData([]);
            return;
        }
        setStaffTransferApiData(res?.data);
        setShowStaffWalletFundTransfersModal(true);
    };

    const getTransferListError = () => {
        //setApiData([]);
    };

    const {
        isLoading: isTransferListLoading,
        mutate: getTransferListMutate,
        error: errorTransferList,
        data: dataTransferList,
        isRefetching: isTransferListRefetching,
    } = useMutation(fetchStaffWalletTransfers, {
        onSuccess: getTransferListSuccess,
        onError: getTransferListError,
    });

    //------- Edit Staff Wallet -------
    const editStaffWalletFunction = async (values) => {
        return await axios.post(`${Config.apiUrl}/wallet/edit`, values, {
            headers: {
                authorization: "Bearer" + " " + user.token,
                "Content-Type": "application/json",
            },
        });
    };

    const onEditStaffWalletSuccess = (data) => {
        if (data?.data?.isSuccess === true) {
            toast.success(data?.data?.msg || "Success");
            setIsEditStaffWallet(false);
            getListMutate();
        } else {
            toast.error(data?.data?.msg || "An Error Occured");
        }
    };

    const onEditStaffWalletError = (data) => {
        toast.error(data?.response?.data?.msg || "An Error Occured");
    };

    const { isLoading: editStaffWalletLoading, mutate: editStaffWalletMutate } =
        useMutation(editStaffWalletFunction, {
            onSuccess: onEditStaffWalletSuccess,
            onError: onEditStaffWalletError,
        });


    return (
        <>
            <BoxContainer>
                <BoxHead>
                    <BoxTitle className="!mb-0 whitespace-nowrap">
                        {"Staff Wallet"}
                        <Underline />
                    </BoxTitle>
                    <Filters setShowCreateWalletModal={setShowCreateWalletModal} />
                </BoxHead>

                {(isLoading || isRefetching) && (
                    <SummarySkeletonLoading count={5} />
                )}
                {!isLoading && !isRefetching && summaryData && (
                    <SummaryCards summaryData={summaryData} onClick={onSummaryBoxClick} setSelectedId={setSelectedId} selectedId={selectedId} />
                )}

                <FilterTableWrapper>
                    <FilterWrapper className="grid grid-cols-1 md:grid-cols-2 gap-4">

                        {/* Left: Total Amount */}
                        <div className="flex items-center">
                            <Text>
                                Total Staff Wallets:{" "}
                                <span className="font-semibold">
                                    {apiData?.length || 0}
                                </span>
                            </Text>
                        </div>

                        {/* Right: Search / Filters */}
                        {/* <div className="flex flex-col gap-3 md:flex-row md:justify-end md:items-center">
                            <SearchFilterBox
                                options={searchOptions}
                                handleFilterChange={handleFilterChange}
                                handleClearFilters={handleClearFilters}
                            />
                        </div> */}
                    </FilterWrapper>

                    {!error && !isLoading && data && (
                        <TableWrapper>
                            <Table
                                apiData={error ? [] : apiData}
                                setSelectedData={setSelectedData}
                                selectedData={selectedData}
                                setViewDetails={setViewDetails}
                                setIsDeleteEntity={setIsDeleteEntity}
                                startDate={startDate}
                                endDate={endDate}
                                setShowTransferFundModal={setShowTransferFundModal}
                                setShowWithdrawFundModal={setShowWithdrawFundModal}
                                getTransferListMutate={getTransferListMutate}
                                setIsEditStaffWallet={setIsEditStaffWallet}
                            />
                            {(!error && apiData?.length === 0 && !isLoading) && (
                                <NotFoundModel />
                            )}
                        </TableWrapper>
                    )}
                </FilterTableWrapper>

                {(isLoading || isRefetching) && <Loading />}

                {/* {error && !isLoading && <NotFoundModel />} */}

                <SideModal
                    isOpen={showCreateWalletModal}
                    onClose={() => setShowCreateWalletModal(false)}
                >
                    <CreateStaffWallet
                        handleClose={handleClose}
                        createWalletLoading={createWalletLoading}
                        createWalletMutate={createWalletMutate}
                        staffListOptions={staffListing}
                        walletBalance={summaryData?.balance || 0}
                    />
                </SideModal>

                <SideModal
                    isOpen={showTransferFundModal}
                    onClose={() => setShowTransferFundModal(false)}
                >
                    <TransferFundToWallet
                        selectedData={selectedData}
                        handleClose={() => setShowTransferFundModal(false)}
                        transferFundLoading={transferFundLoading}
                        transferFundMutate={transferFundMutate}
                        walletBalance={summaryData?.balance || 0}
                    />
                </SideModal>

                <SideModal
                    isOpen={showWithdrawFundModal}
                    onClose={() => setShowWithdrawFundModal(false)}
                >
                    <WithdrawFundFromWallet
                        selectedData={selectedData}
                        handleClose={() => setShowWithdrawFundModal(false)}
                        withdrawFundLoading={withdrawFundLoading}
                        withdrawFundMutate={withdrawFundMutate}
                    />
                </SideModal>

                <SideModal
                    isOpen={showStaffWalletFundTransfersModal}
                    onClose={() => setShowStaffWalletFundTransfersModal(false)}
                >
                    <ViewStaffWalletTransfers
                        setViewModal={setShowStaffWalletFundTransfersModal}
                        selectedData={selectedData}
                        data={apiStaffTransferData}
                    />
                </SideModal>

                <SideModal
                    isOpen={isEditStaff}
                    onClose={() => setIsEditStaffWallet(false)}
                >
                    <EditStaffWallet
                        editStaffWalletMutate={editStaffWalletMutate}
                        editStaffWalletLoading={editStaffWalletLoading}
                        handleClose={() => setIsEditStaffWallet(false)}
                        selectedData={selectedData}
                    />
                </SideModal>

                <DeleteModal
                    isOpen={isDeleteEntity}
                    setOpenModel={setIsDeleteEntity}
                    message="Are you sure you want to delete this beneficiary?"
                    loading={deleteEntityLoading}
                    onClose={() => setIsDeleteEntity(false)}
                    onDelete={() =>
                        deleteEntityMutate({
                            id: selectedData?.id,
                        })
                    }
                />

                {showDeactivateModal && (
                    <ConfirmModal
                        isOpen={showDeactivateModal}
                        setOpenModel={setShowDeactivateModal}
                        title="Deactivate Beneficiary"
                        message="This beneficiary will no longer be available for payouts. You can activate it again later if needed."
                        onClose={() => setShowDeactivateModal(false)}
                        loading={deactivateWalletLoading}
                        onConfirm={() => {
                            setViewDetails(false);
                            deactivateWalletMutate({
                                id: selectedData.id,
                            });
                        }}
                        confirmBtnText="Deactivate"
                        confirmBtnClassName="
                            border border-rose-200
                            bg-rose-50
                            text-rose-600
                            hover:bg-rose-600
                            hover:text-white
                        "
                    />
                )}

                {showActivateModal && (
                    <ConfirmModal
                        isOpen={showActivateModal}
                        setOpenModel={setShowActivateModal}
                        title="Activate Beneficiary"
                        message="This beneficiary will be available for payouts again."
                        onClose={() => setShowActivateModal(false)}
                        loading={activateWalletLoading}
                        onConfirm={() => {
                            setViewDetails(false);
                            activateWalletMutate({
                                id: selectedData.id,
                            });
                        }}
                        confirmBtnText="Activate"
                        confirmBtnClassName="
                             border border-green-200
                            bg-green-50
                            text-green-600
                            hover:bg-green-600
                            hover:text-white
                        "
                    />
                )}

            </BoxContainer>
        </>
    );
};
const Filters = ({ setShowCreateWalletModal }) => {
    return (
        <Formik>
            <Form>
                <FilterContainer>
                    <AddBtn
                        type="button"
                        onClick={() => {
                            setShowCreateWalletModal(true);
                        }}
                    >
                        Add Staff Wallet
                    </AddBtn>
                </FilterContainer>
            </Form>
        </Formik>
    );
};
const TableWrapper = tw.div`mt-4 bg-white rounded-md `;
const AddBtn = tw.button`border whitespace-nowrap border-gray-200 flex items-center justify-center text-white h-full rounded-md px-4 cursor-pointer bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 py-2.5 text-sm transition-colors duration-200`;
const FilterContainer = tw.div`grid grid-cols-2 w-full gap-4 md:flex md:space-x-4 items-end mt-0 md:mt-0`;
const Text = tw.p`text-gray-500 text-sm font-normal`;

export default StaffWallet;